export const clone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const getQueryParams = (url) => {
    const params = new URL(url).searchParams;
    const result = {};

    for (const [key, value] of params) {
        if (result[key]) {
            // If key already exists, push to array
            result[key] = Array.isArray(result[key]) ? [...result[key], value] : [result[key], value];
        } else {
            // Otherwise, set the value
            result[key] = value;
        }
    }
    return result;
}